import React from 'react';
import { Container, Row, Col, Form, Button, Modal, Spinner } from 'react-bootstrap';
import { Multiselect } from 'multiselect-react-dropdown';
import { GiBodyHeight, GiMedicines } from 'react-icons/gi';
import { FaUser, FaEnvelope, FaCalendarAlt, FaUserMd, FaWeight, FaHospital, FaGlobe, FaMapMarked, FaCity, FaPlus, FaMicrophone, FaTransgender, FaPhoneAlt, FaSearch, FaInfoCircle, FaChevronRight, FaChevronLeft, FaBriefcaseMedical } from 'react-icons/fa';
import { DatePicker } from 'antd';
import moment from 'moment';
import MicButton from './voice/MicButton';
import GuidedVoiceIntake from './voice/GuidedVoiceIntake';
import { isSpeechSupported } from './voice/useSpeechRecognition';
import { cleanName, cleanAddress } from './voice/parsers';

const dateFormat = 'DD/MM/yyyy';

/**
 * PatientRegistrationForm — single source of truth for the Patient Registration
 * modal markup (canonical version, formerly duplicated in Case.js and
 * Dashboard.js). It is presentational: the parent component drives it.
 *
 * Props:
 *   ctx                    the parent component instance. The markup reads
 *                          ctx.state.* and calls ctx.<handler>() exactly as the
 *                          inline form used to. Both parents expose the same
 *                          state keys + method names, so behaviour is unchanged.
 *   isHospitalStaff,
 *   isAssociatedDocSelected,
 *   associatedDocList,
 *   dob, ageYears,
 *   ageMonths, ageDays     render-locals the parent destructures from its state.
 */
export default function PatientRegistrationForm({ ctx, isHospitalStaff, isAssociatedDocSelected, associatedDocList, dob, ageYears, ageMonths, ageDays }) {
  return (
                            <Modal show={ctx.state.show} animation={true} centered size="lg">
                                <Modal.Header closeButton onClick={() => ctx.setState({ show: false, isAssociatedDocSelected: false })}>
                                    <Modal.Title>
                                        <h3 className="fs-18 header_title mb-0 text-black">
                                            {
                                                (isHospitalStaff && !isAssociatedDocSelected) ?
                                                    `Select Associated Doctor` :
                                                    `Patient Registration Form`
                                            }
                                        </h3>
                                    </Modal.Title>
                                </Modal.Header>
                                <Modal.Body ref={ctx.formBodyRef} style={{ position: 'relative' }}>
                                    <GuidedVoiceIntake
                                        show={ctx.state.showGuidedVoice}
                                        onClose={() => ctx.setState({ showGuidedVoice: false })}
                                        container={ctx.formBodyRef}
                                        optionData={{
                                            genderArr: ctx.state.genderArr,
                                            bloodGroupArr: ctx.state.bloodGroupArr,
                                            religionArr: ctx.state.religionArr,
                                            educationArr: ctx.state.educationArr,
                                            occupationArr: ctx.state.occupationArr,
                                            maritalStatusArr: ctx.state.maritalStatusArr,
                                            idProofTypeArr: ctx.state.idProofTypeArr,
                                            relationArr: ctx.state.relationArr,
                                            instituteArr: ctx.state.instituteArr,
                                            patientTypeArr: ctx.state.patientTypeArr,
                                            countryArr: ctx.state.countryArr,
                                            filteredCountryList: ctx.state.filteredCountryList,
                                            filteredStateList: ctx.state.filteredStateList,
                                            filteredCityList: ctx.state.filteredCityList,
                                        }}
                                        onSetDob={ctx.setDOB}
                                        onCombo={ctx.handleVoiceCombo}
                                    />
                                    <Container className="p-2" style={{ width: "95%" }}>
                                        {
                                            (isHospitalStaff && !isAssociatedDocSelected) ?
                                                <Col lg='6'>
                                                    <Form.Group className='input-group mb-6'>
                                                        <span className="input-group-addon"><FaUserMd className='' /></span>
                                                        <Form.Control as="select" id="" name='docList' onChange={ctx.handleChange}>
                                                            <option value="DEFAULT" disabled selected>- Select Doctor -</option>
                                                            {
                                                                // associatedDocList.map(function (d) {
                                                                //     return (<option value={d.id}>{d.name}</option>)
                                                                // })
                                                                associatedDocList.map(function (d) {
                                                                    return (<option key={d.id} value={d.id}>{d.name}</option>)
                                                                  })
    
                                                            }
                                                        </Form.Control>
                                                    </Form.Group>
                                                </Col> :
                                                <div>
                                                {/* Shown even without speech recognition (e.g. Firefox): the guided
                                                    flow falls back to keyboard entry, still speaking each question. */}
                                                <div className="d-flex justify-content-end mb-2">
                                                    <Button variant="outline-info" size="sm" onClick={() => ctx.setState({ showGuidedVoice: true })}
                                                        title={isSpeechSupported
                                                            ? 'Walk through the form question by question, by voice'
                                                            : 'Walk through the form question by question — this browser has no speech recognition, so answers are typed'}>
                                                        <FaMicrophone className="mb-1" /> Guided {isSpeechSupported ? 'Voice' : 'Form'} Fill
                                                    </Button>
                                                </div>
                                                <div id="nextTab1">
                                                    <Row>
                                                        <Col lg='6'>
                                                            <Form.Group className='input-group mb-6'>
                                                                <span className="input-group-addon"><FaCalendarAlt className='' /></span>
                                                                <Form.Control type='text' disabled placeholder='Date of Registeration' value={ctx.getTodayDate()} name='registrationDate' />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col lg='6'>
                                                            <Form.Group className='input-group mb-6'>
                                                                <span className="input-group-addon"><FaUserMd className='' /></span>
                                                                <Form.Control type='text' disabled placeholder='Name of Doctor' name='docName'
                                                                    value={ctx.state.doctor.firstName + ' ' + ctx.state.doctor.lastName} onChange={ctx.handleChange} />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col lg='6'>
                                                            <Form.Group className='input-group mb-6'>
                                                                <span className="input-group-addon"><FaUser className='' /></span>
                                                                <Form.Control type='text' placeholder='First Name' name='firstName' onChange={ctx.handleChange} />
                                                                <MicButton label='First Name' parser={cleanName} />
                                                                <div className="invalid-feedback">{ctx.state.patientRegErrors["firstName"]}</div>
                                                            </Form.Group>
                                                        </Col>
                                                        <Col lg='6'>
                                                            <Form.Group className='input-group mb-6'>
                                                                <span className="input-group-addon"><FaUser className='' /></span>
                                                                <Form.Control type='text' placeholder='Middle Name' name='middleName' onChange={ctx.handleChange} />
                                                                <MicButton label='Middle Name' parser={cleanName} />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col lg='6'>
                                                            <Form.Group className='input-group mb-6'>
                                                                <span className="input-group-addon"><FaUser className='' /></span>
                                                                <Form.Control type='text' placeholder='Last Name' name='lastName' onChange={ctx.handleChange} />
                                                                <MicButton label='Last Name' parser={cleanName} />
                                                                <div className="invalid-feedback">{ctx.state.patientRegErrors["lastName"]}</div>
                                                            </Form.Group>
                                                        </Col>
                                                        <Col lg='6'>
                                                            <Form.Group className='input-group mb-6'>
                                                                <span className="input-group-addon"><FaEnvelope className='' /></span>
                                                                <Form.Control type='email' placeholder='Email Address' name='email' onChange={ctx.handleChange} />
                                                                <MicButton label='Email Address' />
                                                                <div className="invalid-feedback">{ctx.state.patientRegErrors["email"]}</div>
                                                            </Form.Group>
                                                        </Col>
                                                        <Col lg='6'>
                                                            <Form.Group className='input-group mb-6'>
                                                            <DatePicker
                                                                onChange={date => ctx.setDOB(date)}
                                                                placeholder="Date of Birth"
                                                                format={dateFormat}
                                                                value={ctx.getDobPickerValue(dob)}
                                                                disabledDate={d => !d || d.isAfter(moment())}
                                                                className="full-width"
                                                            />
                                                                <div className="invalid-feedback">{ctx.state.patientRegErrors["dob"]}</div>
                                                            </Form.Group>
                                                        </Col>
                                                        <Col lg='6'>
                                                                        <Form.Group className='mb-0'>
                                                                            <Form.Label className="mr-3">Age</Form.Label>
                                                                            <div className="d-inline-flex">
                                                                                <Form.Control
                                                                                    type="number"
                                                                                    min="0"
                                                                                    max="99"
                                                                                    maxLength="2"
                                                                                    placeholder="Years"
                                                                                    value={ageYears}
                                                                                    onChange={(e) => ctx.handleAgeChange('ageYears', e.target.value)}
                                                                                    onInput={(e) => e.target.value = e.target.value.slice(0, 2)} // Additional input restriction
                                                                                    className="mr-2"
                                                                                    style={{ width: '80px' }}
                                                                                />
                                                                                <Form.Control
                                                                                    type="number"
                                                                                    min="0"
                                                                                    max="11"
                                                                                    placeholder="Months"
                                                                                    value={ageMonths}
                                                                                    onChange={(e) => ctx.handleAgeChange('ageMonths', e.target.value)}
                                                                                    className="mr-2"
                                                                                    style={{ width: '80px' }}
                                                                                />
                                                                                <Form.Control
                                                                                    type="number"
                                                                                    min="0"
                                                                                    max="30"
                                                                                    placeholder="Days"
                                                                                    value={ageDays}
                                                                                    onChange={(e) => ctx.handleAgeChange('ageDays', e.target.value)}
                                                                                    style={{ width: '80px' }}
                                                                                />
                                                                            </div>
                                                                        </Form.Group>
                                                                    </Col>
                                                        <Col lg='6'>
                                                            <Form.Group className='input-group mb-6'>
                                                                <span className="input-group-addon"><FaTransgender className='' /></span>
                                                                <Form.Control as="select" id="" name='gender' onChange={ctx.handleChange}>
                                                                    <option value="DEFAULT" disabled selected>- Select Gender -</option>
                                                                    {ctx.state.genderArr.map(function (d) {
                                                                        return (<option key={d.id} value={d.id}>{d.name}</option>)
                                                                    })}
                                                                </Form.Control>
                                                                <div className="invalid-feedback">{ctx.state.patientRegErrors["gender"]}</div>
                                                            </Form.Group>
                                                        </Col>
                                                        {/* Blood Group Field */}
                                                        <Col lg='6'>
                                                          <Form.Group className='input-group mb-6'>
                                                            <span className="input-group-addon"><FaUser className='' /></span>
                                                            <Form.Control 
                                                              as="select" 
                                                              id="" 
                                                              name='bloodGroup' 
                                                              onChange={ctx.handleChange}
                                                              isInvalid={!!ctx.state.patientRegErrors["bloodGroup"]}
                                                              defaultValue="DEFAULT"
                                                            >
                                                              {ctx.state.bloodGroupArr && ctx.state.bloodGroupArr.map((option, index) => (
                                                                <option key={index} value={index === 0 ? "DEFAULT" : option} disabled={index === 0}>
                                                                  {option}
                                                                </option>
                                                              ))}
                                                            </Form.Control>
                                                            <div className="invalid-feedback">{ctx.state.patientRegErrors["bloodGroup"]}</div>
                                                          </Form.Group>
                                                        </Col>
                                                        
                                                        <Col lg='12'><h5 className="mt-3 mb-3">Additional Information</h5></Col>
                                                        
                                                        <Col lg='6'>
                                                          <Form.Group className='input-group mb-6'>
                                                            <span className="input-group-addon"><FaUser className='' /></span>
                                                           {/* Example for religion select */}
                                                        <Form.Control as="select" id="" name='religion' onChange={ctx.handleChange} defaultValue="DEFAULT">
                                                          {ctx.state.religionArr && ctx.state.religionArr.map((option, index) => (
                                                            <option key={index} value={index === 0 ? "DEFAULT" : option} disabled={index === 0}>
                                                              {option}
                                                            </option>
                                                          ))}
                                                        </Form.Control>
                                                          </Form.Group>
                                                        </Col>
                                                        
                                                        <Col lg='6'>
                                                          <Form.Group className='input-group mb-6'>
                                                            <span className="input-group-addon"><FaUser className='' /></span>
                                                            <Form.Control as="select" id="" name='education' onChange={ctx.handleChange} defaultValue="DEFAULT">
                                                          {ctx.state.educationArr && ctx.state.educationArr.map((option, index) => (
                                                            <option key={index} value={index === 0 ? "DEFAULT" : option} disabled={index === 0}>
                                                              {option}
                                                            </option>
                                                          ))}
                                                        </Form.Control>
                                                          </Form.Group>
                                                        </Col>
                                                        
                                                        <Col lg='6'>
                                                          <Form.Group className='input-group mb-6'>
                                                            <span className="input-group-addon"><FaUser className='' /></span>
                                                            <Form.Control as="select" id="" name='occupation' onChange={ctx.handleChange} defaultValue="DEFAULT">
                                                          {ctx.state.occupationArr && ctx.state.occupationArr.map((option, index) => (
                                                            <option key={index} value={index === 0 ? "DEFAULT" : option} disabled={index === 0}>
                                                              {option}
                                                            </option>
                                                          ))}
                                                        </Form.Control>
                                                          </Form.Group>
                                                        </Col>
                                                        
                                                        <Col lg='6'>
                                                          <Form.Group className='input-group mb-6'>
                                                            <span className="input-group-addon"><FaUser className='' /></span>
                                                            <Form.Control as="select" id="" name='maritalStatus' onChange={ctx.handleChange} defaultValue="DEFAULT">
                                                          {ctx.state.maritalStatusArr && ctx.state.maritalStatusArr.map((option, index) => (
                                                            <option key={index} value={index === 0 ? "DEFAULT" : option} disabled={index === 0}>
                                                              {option}
                                                            </option>
                                                          ))}
                                                        </Form.Control>
                                                          </Form.Group>
                                                        </Col>
                                                        
                                                        <Col lg='6'>
                                                          <Form.Group className='input-group mb-6'>
                                                            <span className="input-group-addon"><FaUser className='' /></span>
                                                            <Form.Control as="select" id="" name='idProofType' onChange={ctx.handleChange} defaultValue="DEFAULT">
                                                          {ctx.state.idProofTypeArr && ctx.state.idProofTypeArr.map((option, index) => (
                                                            <option key={index} value={index === 0 ? "DEFAULT" : option} disabled={index === 0}>
                                                              {option}
                                                            </option>
                                                          ))}
                                                        </Form.Control>
                                                          </Form.Group>
                                                        </Col>
                                                        
                                                        <Col lg='6'>
                                                          <Form.Group className='input-group mb-6'>
                                                            <span className="input-group-addon"><FaUser className='' /></span>
                                                            <Form.Control type='text' placeholder='ID Proof Number' name='idProofNumber' onChange={ctx.handleChange} />
                                                            <MicButton label='ID Proof Number' />
                                                          </Form.Group>
                                                        </Col>
                                                        
                                                        <Col lg='12'><h5 className="mt-3 mb-3">Emergency Contact</h5></Col>
                                                        
                                                        <Col lg='6'>
                                                          <Form.Group className='input-group mb-6'>
                                                            <span className="input-group-addon"><FaUser className='' /></span>
                                                            <Form.Control 
                                                              type='text' 
                                                              placeholder='Emergency Contact Person' 
                                                              name='emergencyContactPerson'
                                                              onChange={ctx.handleChange}
                                                              isInvalid={!!ctx.state.patientRegErrors["emergencyContactPerson"]}
                                                            />
                                                            <MicButton label='Emergency Contact Person' parser={cleanName} />
                                                            <div className="invalid-feedback">{ctx.state.patientRegErrors["emergencyContactPerson"]}</div>
                                                          </Form.Group>
                                                        </Col>
                                                        
                                                        {/* Emergency Contact Relation Field */}
                                                        <Col lg='6'>
                                                          <Form.Group className='input-group mb-6'>
                                                            <span className="input-group-addon"><FaUser className='' /></span>
                                                            <Form.Control 
                                                              as="select" 
                                                              name='emergencyContactRelation' 
                                                              value={ctx.state.emergencyContactRelation || ""}
                                                              onChange={ctx.handleChange}
                                                              isInvalid={!!ctx.state.patientRegErrors["emergencyContactRelation"]}
                                                            >
                                                              <option value="">- Select Relation -</option>
                                                              {ctx.state.relationArr && ctx.state.relationArr.map((option, index) => (
                                                                <option 
                                                                  key={index} 
                                                                  value={option} 
                                                                  disabled={index === 0}
                                                                >
                                                                  {option}
                                                                </option>
                                                              ))}
                                                            </Form.Control>
                                                            <div className="invalid-feedback">{ctx.state.patientRegErrors["emergencyContactRelation"]}</div>
                                                          </Form.Group>
                                                        </Col>
                                                        
                                                        <Col lg='6'>
                                                          <Form.Group className='input-group mb-6'>
                                                          <Col lg='6'>
                                                              <Form.Group className='input-group'>
                                                                <span className="input-group-addon"><FaPhoneAlt className='' /></span>
                                                                <Form.Control 
                                                                  as="select" 
                                                                  id="" 
                                                                  name='emergencyCountryCode' 
                                                                  style={{ maxWidth: "130px" }} 
                                                                  onChange={ctx.handleChange}
                                                                  isInvalid={!!ctx.state.patientRegErrors["emergencyCountryCode"]}
                                                                >
                                                                  <option value="DEFAULT" disabled selected>- Area Code -</option>
                                                                  {ctx.state.countryArr.map(function (d) {
                                                                    return (<option key={d.id} value={d.id}>{d.name}</option>)
                                                                  })}
                                                                </Form.Control>
                                                                <div className="invalid-feedback" style={{ display: 'block' }}>
                                                                  {ctx.state.patientRegErrors["emergencyCountryCode"]}
                                                                </div>
                                                              </Form.Group>
                                                            </Col>
                                                            {/* <Form.Control as="select" className="select-sm" name='emergencyMobileType' onChange={ctx.handleChange}>
                                                              <option value="DEFAULT" disabled selected>Select</option>
                                                              <option value="1">Mobile</option>
                                                              <option value="2">Landline</option>
                                                            </Form.Control> */}
                                                            <Form.Control 
                                                              type='text' 
                                                              placeholder='Emergency Mobile Number' 
                                                              name='emergencyMobileNumber' 
                                                              onChange={ctx.handleChange}
                                                              isInvalid={!!ctx.state.patientRegErrors["emergencyMobileNumber"]}
                                                            />
                                                            <div className="invalid-feedback">{ctx.state.patientRegErrors["emergencyMobileNumber"]}</div>
                                                         
                                                              </Form.Group>
                                                        </Col>
                                                        <Col lg='6'>   
      <Form.Group className='input-group mb-6'>   
        <Col lg='6'>       
          <Form.Group className='input-group'>         
            <span className="input-group-addon"><FaPhoneAlt className='' /></span>         
            <Form.Control            
              as="select"            
              id=""            
              name='emergencyLandlineCountryCode'            
              style={{ maxWidth: "130px" }}            
              onChange={ctx.handleChange}           
              isInvalid={!!ctx.state.patientRegErrors["emergencyLandlineCountryCode"]}         
            >           
              <option value="DEFAULT" disabled selected>- Area Code -</option>           
              {ctx.state.countryArr.map(function (d) {             
                return (<option key={d.id} value={d.id}>{d.name}</option>)           
              })}         
            </Form.Control>         
            <div className="invalid-feedback" style={{ display: 'block' }}>           
              {ctx.state.patientRegErrors["emergencyLandlineCountryCode"]}         
            </div>       
          </Form.Group>     
        </Col>     
        <Form.Control        
          type='text'        
          placeholder='Emergency Landline Number'        
          name='emergencyLandlineNumber'        
          onChange={ctx.handleChange}       
          isInvalid={!!ctx.state.patientRegErrors["emergencyLandlineNumber"]}     
        />     
        <div className="invalid-feedback">{ctx.state.patientRegErrors["emergencyLandlineNumber"]}</div>         
      </Form.Group> 
    </Col>
                                                        {/* <Col lg='6'>
                                                          <Form.Group className='input-group mb-6'> */}
                                                            
                                                            {/* <Form.Control as="select" className="select-sm" name='emergencyLandlineType' onChange={ctx.handleChange}>
                                                              <option value="DEFAULT" disabled selected>Select</option>
                                                              <option value="1">Mobile</option>
                                                              <option value="2">Landline</option>
                                                            </Form.Control> */}
                                                            {/* <Form.Control type='text' placeholder='Emergency Landline Number' name='emergencyLandlineNumber' onChange={ctx.handleChange} />
                                                          </Form.Group>
                                                        </Col> */}
    
                                                        {/* <Col lg='6'>
                                                            <Form.Group className='input-group mb-6'>
                                                                <span className="input-group-addon"><GiBodyHeight className='' /></span>
                                                                <Form.Control type='number' placeholder='Height' name='height' className="mr-2" min={1} onChange={ctx.handleChange} />
                                                                <Form.Control as="select" id="" name='heightUnit' onChange={ctx.handleChange}>
                                                                    <option value="DEFAULT" disabled selected>- Select Unit -</option>
                                                                    {ctx.state.heightArr.map(function (d) {
                                                                        return ((d.name ==='cm') ? <option key={d.id} value={d.id} selected>{d.name}</option> : <option key={d.id} value={d.id}>{d.name}</option>)
                                                                    })}
                                                                </Form.Control>
                                                                <div className="invalid-feedback">{ctx.state.patientRegErrors["height"]}</div>
                                                            </Form.Group>
                                                        </Col>
                                                        <Col lg='6'>
                                                            <Form.Group className='input-group mb-6'>
                                                                <span className="input-group-addon"><FaWeight className='' /></span>
                                                                <Form.Control type='number' placeholder='Weight' className="mr-2" name='weight' min={1} onChange={ctx.handleChange} />
                                                                <Form.Control as="select" id="" name='weightUnit' onChange={ctx.handleChange}>
                                                                    <option value="DEFAULT" disabled selected>- Select Unit -</option>
                                                                    {ctx.state.weightArr.map(function (d) {
                                                                        return ((d.name ==='KG') ? <option key={d.id} value={d.id} selected>{d.name}</option> : <option key={d.id} value={d.id}>{d.name}</option>)
                                                                    })}
                                                                </Form.Control>
                                                                <div className="invalid-feedback">{ctx.state.patientRegErrors["weight"]}</div>
                                                            </Form.Group>
                                                        </Col> */}
     <Col lg='12'><h5 className="mt-3 mb-3">Contact Details</h5></Col>
                                                        {/* Contact Information Section */}
                                                          <Col lg='6'>
                                                            <Form.Row className='mb-6'>
                                                              <Col lg='6'>
                                                                <Form.Group className='input-group'>
                                                                  <span className="input-group-addon"><FaPhoneAlt className='' /></span>
                                                                  <Form.Control as="select" id="" name='country' style={{ maxWidth: "130px" }} onChange={ctx.handleChange}>
                                                                    <option value="DEFAULT" disabled selected>- Area Code -</option>
                                                                    {ctx.state.countryArr.map(function (d) {
                                                                      return (<option key={d.id} value={d.id}>{d.name}</option>)
                                                                    })}
                                                                  </Form.Control>
                                                                  <div className="invalid-feedback" style={{ display: 'block' }}>
                                                                    {ctx.state.patientRegErrors["country"]}
                                                                  </div>
                                                                </Form.Group>
                                                              </Col>
                                                              <Col lg='6'>
                                                                <Form.Group className='input-group'>
                                                                  <Form.Control type='number' maxLength='10' id="" placeholder='Contact No' name='phoneNumber1' onChange={ctx.handleChange} />
                                                                  <div className="invalid-feedback" style={{ display: 'block' }}>
                                                                    {ctx.state.patientRegErrors["phoneNumber1"]}
                                                                  </div>
                                                                </Form.Group>
                                                              </Col>
                                                            </Form.Row>
                                                          </Col>
                                                        
                                                          {/* Separate Telephone Section */}
                                                          <Col lg='6'>
                                                            <Form.Group className='input-group mb-6'>
                                                              <span className="input-group-addon"><FaPhoneAlt className='' /></span>
                                                              {/* Telephone Number field */}
                                                        <Form.Control 
                                                            type='text' 
                                                            placeholder='Telephone Number' 
                                                            name='telephoneNumber' 
                                                            value={ctx.state.telephoneNumber || ''}
                                                            onChange={ctx.handleChange}
                                                            onKeyPress={(event) => {
                                                                if (!/[0-9]/.test(event.key)) {
                                                                    event.preventDefault();
                                                                }
                                                            }}
                                                            isInvalid={!!ctx.state.patientRegErrors["telephoneNumber"]}
                                                        />
                                                              <div className="invalid-feedback" style={{ display: 'block' }}>
                                                                {ctx.state.patientRegErrors["telephoneNumber"]}
                                                              </div>
                                                            </Form.Group>
                                                          </Col>
                                                        
                                                          {/* Permanent Address Section - Updated with connected dropdown fields */}
                                                        <Col lg='12'><h5 className="mt-4 mb-3">Permanent Address</h5></Col>
                                                        
                                                        <Col lg='6'>
                                                          <Form.Group className='input-group mb-6'>
                                                            <span className="input-group-addon"><FaUser className='' /></span>
                                                            <Form.Control type='text' placeholder='Address Line 1' name='addressline1' onChange={ctx.handleChange} />
                                                            <MicButton label='Address Line 1' long parser={cleanAddress} />
                                                            <div className="invalid-feedback">{ctx.state.patientRegErrors["addressline1"]}</div>
                                                          </Form.Group>
                                                        </Col>
                                                        <Col lg='6'>
                                                          <Form.Group className='input-group mb-6'>
                                                            <span className="input-group-addon"><FaUser className='' /></span>
                                                            <Form.Control type='text' placeholder='Address Line 2' name='addressline2' onChange={ctx.handleChange} />
                                                            <MicButton label='Address Line 2' long parser={cleanAddress} />
                                                          </Form.Group>
                                                        </Col>
                                                        
                                                       {/* Permanent Address - Country */}
      {/* Permanent Address - Country */}
      <Col lg='6'>
        <div className="position-relative">
          <Form.Group className='input-group mb-6'>
            <span className="input-group-addon"><FaGlobe className='' /></span>
            <Form.Control 
              type="text"
              placeholder="Search country..."
              value={ctx.state.countrySearchTerm}
              onChange={ctx.handleCountrySearch}
              onClick={() => ctx.setState({ isCountryDropdownOpen: true })}
              autoComplete="off"
            />
            <div className="invalid-feedback">
              {ctx.state.patientRegErrors["newCountry"]}
            </div>
          </Form.Group>
          
          {ctx.state.isCountryDropdownOpen && (
            <div className="dropdown-menu show w-100" 
                 style={{ maxHeight: '200px', overflowY: 'auto', position: 'absolute', zIndex: 1000, top: '38px' }}>
              <div className="dropdown-item" onClick={() => {
                ctx.handleNewCountryChange({ target: { value: "" } });
                ctx.setState({ countrySearchTerm: "", isCountryDropdownOpen: false });
              }}>
                - Select Country -
              </div>
              {ctx.state.filteredCountryList.map(country => (
                <div 
                  key={country.id} 
                  className="dropdown-item"
                  onClick={() => {
                    ctx.handleNewCountryChange({ target: { value: country.id } });
                    ctx.setState({ countrySearchTerm: country.name, isCountryDropdownOpen: false });
                  }}
                >
                  {country.name}
                </div>
              ))}
            </div>
          )}
        </div>
      </Col>
      
      {/* Permanent Address - State */}
      <Col lg='6'>
        <div className="position-relative">
          <Form.Group className='input-group mb-6'>
            <span className="input-group-addon"><FaMapMarked className='' /></span>
            <Form.Control 
              type="text"
              placeholder="Search state..."
              value={ctx.state.stateSearchTerm}
              onChange={ctx.handleStateSearch}
              onClick={() => !ctx.state.isNewStateDropdownDisabled && ctx.setState({ isStateDropdownOpen: true })}
              disabled={ctx.state.isNewStateDropdownDisabled}
              autoComplete="off"
            />
            <div className="invalid-feedback">
              {ctx.state.patientRegErrors["newState"]}
            </div>
          </Form.Group>
          
          {ctx.state.isStateDropdownOpen && !ctx.state.isNewStateDropdownDisabled && (
            <div className="dropdown-menu show w-100" 
                 style={{ maxHeight: '200px', overflowY: 'auto', position: 'absolute', zIndex: 1000, top: '38px' }}>
              <div className="dropdown-item" onClick={() => {
                ctx.handleNewStateChange({ target: { value: "" } });
                ctx.setState({ stateSearchTerm: "", isStateDropdownOpen: false });
              }}>
                - Select State -
              </div>
              {ctx.state.filteredStateList.map(state => (
                <div 
                  key={state.id} 
                  className="dropdown-item"
                  onClick={() => {
                    ctx.handleNewStateChange({ target: { value: state.id } });
                    ctx.setState({ stateSearchTerm: state.name, isStateDropdownOpen: false });
                  }}
                >
                  {state.name}
                </div>
              ))}
            </div>
          )}
        </div>
      </Col>
      
      {/* Permanent Address - City */}
      <Col lg='6'>
        <div className="position-relative">
          <Form.Group className='input-group mb-6'>
            <span className="input-group-addon"><FaCity className='' /></span>
            <Form.Control 
              type="text"
              placeholder="Search city..."
              value={ctx.state.citySearchTerm}
              onChange={ctx.handleCitySearch}
              onClick={() => !ctx.state.isNewCityDropdownDisabled && ctx.setState({ isCityDropdownOpen: true })}
              disabled={ctx.state.isNewCityDropdownDisabled}
              autoComplete="off"
            />
            <div className="invalid-feedback">
              {ctx.state.patientRegErrors["newCity"]}
            </div>
          </Form.Group>
          
          {ctx.state.isCityDropdownOpen && !ctx.state.isNewCityDropdownDisabled && (
            <div className="dropdown-menu show w-100" 
                 style={{ maxHeight: '200px', overflowY: 'auto', position: 'absolute', zIndex: 1000, top: '38px' }}>
              <div className="dropdown-item" onClick={() => {
                ctx.handleNewCityChange({ target: { value: "" } });
                ctx.setState({ citySearchTerm: "", isCityDropdownOpen: false });
              }}>
                - Select City -
              </div>
              {ctx.state.filteredCityList.map(city => (
                <div 
                  key={city.id} 
                  className="dropdown-item"
                  onClick={() => {
                    ctx.handleNewCityChange({ target: { value: city.id } });
                    ctx.setState({ citySearchTerm: city.name, isCityDropdownOpen: false });
                  }}
                >
                  {city.name}
                </div>
              ))}
            </div>
          )}
        </div>
      </Col>
                                                        <Col lg='6'>
                                                          <Form.Group className='input-group mb-6'>
                                                            <span className="input-group-addon"><FaUser className='' /></span>
                                                            <Form.Control type='number' maxLength='10' placeholder='Pin Code' name='pinCode' onChange={ctx.handleChange} />
                                                            <div className="invalid-feedback">{ctx.state.patientRegErrors["pinCode"]}</div>
                                                          </Form.Group>
                                                        </Col>
                                                        
                                                                                                                       {/* Current Address Section - Updated with connected dropdown fields */}
                                                        <Col lg='12'><h5 className="mt-3 mb-3">Current Address Details:</h5></Col>
                                                        
                                                        <Col lg='12'>
                                                          <Form.Group className="mb-3" controlId="formBasicCheckbox">
                                                          <Form.Check 
                                                                    type="checkbox" 
                                                                    label="Same as Permanent Address" 
                                                                    checked={ctx.state.sameAsPermanent}
                                                                    onChange={ctx.handleSameAddressChange}
                                                                />
                                                          </Form.Group>
                                                        </Col>
                                                        
                                                        <Col lg='6'>
                                                          <Form.Group className='input-group mb-6'>
                                                            <span className="input-group-addon"><FaUser className='' /></span>
                                                            <Form.Control 
                                                              type='text' 
                                                              placeholder='Address Line 1' 
                                                              name='currentAddressLine1'
                                                              value={ctx.state.sameAsPermanent ? ctx.state.addressLine1 : ctx.state.currentAddressLine1}
                                                              onChange={ctx.handleChange}
                                                              disabled={ctx.state.sameAsPermanent}
                                                            />
                                                            {!ctx.state.sameAsPermanent && <MicButton label='Current Address Line 1' long parser={cleanAddress} />}
                                                          </Form.Group>
                                                        </Col>
                                                        
                                                        <Col lg='6'>
                                                          <Form.Group className='input-group mb-6'>
                                                            <span className="input-group-addon"><FaUser className='' /></span>
                                                            <Form.Control 
                                                              type='text' 
                                                              placeholder='Address Line 2' 
                                                              name='currentAddressLine2'
                                                              value={ctx.state.sameAsPermanent ? ctx.state.addressLine2 : ctx.state.currentAddressLine2}
                                                              onChange={ctx.handleChange}
                                                              disabled={ctx.state.sameAsPermanent}
                                                            />
                                                            {!ctx.state.sameAsPermanent && <MicButton label='Current Address Line 2' long parser={cleanAddress} />}
                                                          </Form.Group>
                                                        </Col>
                                                        
                                                        {/* Current Address - Country */}
          {/* Current Address - Country */}
          <Col lg='6'>
            <div className="position-relative">
              <Form.Group className='input-group mb-6'>
                <span className="input-group-addon"><FaGlobe className='' /></span>
                <Form.Control 
                  type="text"
                  placeholder="Search country..."
                  value={ctx.state.sameAsPermanent ? ctx.state.countrySearchTerm : ctx.state.currentCountrySearchTerm}
                  onChange={ctx.handleCurrentCountrySearch}
                  onClick={() => !ctx.state.sameAsPermanent && ctx.setState({ isCurrentCountryDropdownOpen: true })}
                  disabled={ctx.state.sameAsPermanent}
                  autoComplete="off"
                />
                <div className="invalid-feedback">
                  {ctx.state.patientRegErrors["currentCountry"]}
                </div>
              </Form.Group>
              
              {ctx.state.isCurrentCountryDropdownOpen && !ctx.state.sameAsPermanent && (
                <div className="dropdown-menu show w-100" 
                     style={{ maxHeight: '200px', overflowY: 'auto', position: 'absolute', zIndex: 1000, top: '38px' }}>
                  <div className="dropdown-item" onClick={() => {
                    ctx.handleCurrentCountryChange({ target: { value: "" } });
                    ctx.setState({ currentCountrySearchTerm: "", isCurrentCountryDropdownOpen: false });
                  }}>
                    - Select Country -
                  </div>
                  {ctx.state.filteredCurrentCountryList.map(country => (
                    <div 
                      key={country.id} 
                      className="dropdown-item"
                      onClick={() => {
                        ctx.handleCurrentCountryChange({ target: { value: country.id } });
                        ctx.setState({ currentCountrySearchTerm: country.name, isCurrentCountryDropdownOpen: false });
                      }}
                    >
                      {country.name}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </Col>
          
          {/* Current Address - State */}
          <Col lg='6'>
            <div className="position-relative">
              <Form.Group className='input-group mb-6'>
                <span className="input-group-addon"><FaMapMarked className='' /></span>
                <Form.Control 
                  type="text"
                  placeholder="Search state..."
                  value={ctx.state.sameAsPermanent ? ctx.state.stateSearchTerm : ctx.state.currentStateSearchTerm}
                  onChange={ctx.handleCurrentStateSearch}
                  onClick={() => !ctx.state.sameAsPermanent && !ctx.state.isCurrentStateDropdownDisabled && ctx.setState({ isCurrentStateDropdownOpen: true })}
                  disabled={ctx.state.sameAsPermanent || ctx.state.isCurrentStateDropdownDisabled}
                  autoComplete="off"
                />
                <div className="invalid-feedback">
                  {ctx.state.patientRegErrors["currentState"]}
                </div>
              </Form.Group>
              
              {ctx.state.isCurrentStateDropdownOpen && !ctx.state.sameAsPermanent && !ctx.state.isCurrentStateDropdownDisabled && (
                <div className="dropdown-menu show w-100" 
                     style={{ maxHeight: '200px', overflowY: 'auto', position: 'absolute', zIndex: 1000, top: '38px' }}>
                  <div className="dropdown-item" onClick={() => {
                    ctx.handleCurrentStateChange({ target: { value: "" } });
                    ctx.setState({ currentStateSearchTerm: "", isCurrentStateDropdownOpen: false });
                  }}>
                    - Select State -
                  </div>
                  {ctx.state.filteredCurrentStateList.map(state => (
                    <div 
                      key={state.id} 
                      className="dropdown-item"
                      onClick={() => {
                        ctx.handleCurrentStateChange({ target: { value: state.id } });
                        ctx.setState({ currentStateSearchTerm: state.name, isCurrentStateDropdownOpen: false });
                      }}
                    >
                      {state.name}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </Col>
          
          {/* Current Address - City */}
          <Col lg='6'>
            <div className="position-relative">
              <Form.Group className='input-group mb-6'>
                <span className="input-group-addon"><FaCity className='' /></span>
                <Form.Control 
                  type="text"
                  placeholder="Search city..."
                  value={ctx.state.sameAsPermanent ? ctx.state.citySearchTerm : ctx.state.currentCitySearchTerm}
                  onChange={ctx.handleCurrentCitySearch}
                  onClick={() => !ctx.state.sameAsPermanent && !ctx.state.isCurrentCityDropdownDisabled && ctx.setState({ isCurrentCityDropdownOpen: true })}
                  disabled={ctx.state.sameAsPermanent || ctx.state.isCurrentCityDropdownDisabled}
                  autoComplete="off"
                />
                <div className="invalid-feedback">
                  {ctx.state.patientRegErrors["currentCity"]}
                </div>
              </Form.Group>
              
              {ctx.state.isCurrentCityDropdownOpen && !ctx.state.sameAsPermanent && !ctx.state.isCurrentCityDropdownDisabled && (
                <div className="dropdown-menu show w-100" 
                     style={{ maxHeight: '200px', overflowY: 'auto', position: 'absolute', zIndex: 1000, top: '38px' }}>
                  <div className="dropdown-item" onClick={() => {
                    ctx.handleCurrentCityChange({ target: { value: "" } });
                    ctx.setState({ currentCitySearchTerm: "", isCurrentCityDropdownOpen: false });
                  }}>
                    - Select City -
                  </div>
                  {ctx.state.filteredCurrentCityList.map(city => (
                    <div 
                      key={city.id} 
                      className="dropdown-item"
                      onClick={() => {
                        ctx.handleCurrentCityChange({ target: { value: city.id } });
                        ctx.setState({ currentCitySearchTerm: city.name, isCurrentCityDropdownOpen: false });
                      }}
                    >
                      {city.name}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </Col>
                                                        
                                                        <Col lg='6'>
                                                          <Form.Group className='input-group mb-6'>
                                                            <span className="input-group-addon"><FaUser className='' /></span>
                                                            <Form.Control 
                                                              type='text' 
                                                              placeholder='Pin Code' 
                                                              name='currentPinCode' 
                                                              value={ctx.state.sameAsPermanent ? ctx.state.pinCode : ctx.state.currentPinCode}
                                                              onChange={ctx.handleChange} 
                                                              disabled={ctx.state.sameAsPermanent}
                                                            />
                                                          </Form.Group>
                                                        </Col>
                                                        
                                                                                                           
                                                        
                                                        <Col lg='12'><h5 className="mt-3 mb-3">Hospital Associated Details</h5></Col>
                                                        
                                                        {/* Primary Consultant Field */}
                                                        <Col lg='6'>
                                                          <Form.Group className='input-group mb-6'>
                                                            <span className="input-group-addon"><FaUser className='' /></span>
                                                            <Form.Control 
                                                              type='text' 
                                                              placeholder='Primary Consultant' 
                                                              name='primaryConsultant' 
                                                              onChange={ctx.handleChange}
                                                              isInvalid={!!ctx.state.patientRegErrors["primaryConsultant"]} 
                                                            />
                                                            <div className="invalid-feedback">{ctx.state.patientRegErrors["primaryConsultant"]}</div>
                                                          </Form.Group>
                                                        </Col>
                                                        <Col lg='6'>
                                                                                                                            <Form.Group className='input-group mb-6'>
                                                                                                                                <span className="input-group-addon"><FaHospital className='' /></span>
                                                                                                                                <Form.Control as="select" id="" name='institute' onChange={ctx.handleChange} defaultValue="DEFAULT">
                                                                                                                                    <option value="DEFAULT" disabled>- Select Institute -</option>
                                                                                                                                    {ctx.state.instituteArr.map(function (d) {
                                                                                                                                        return (
                                                                                                                                            <option key={d.id} value={d.id}>{d.name}</option>
                                                                                                                                        )
                                                                                                                                    })}
                                                                                                                                </Form.Control>
                                                                                                                                <div className="invalid-feedback">{ctx.state.patientRegErrors["institute"]}</div>
                                                                                                                            </Form.Group>
                                                                                                                        </Col>
                                                        
                                                        {/* Patient Type Field */}
                                                        <Col lg='6'>
                                                          <Form.Group className='input-group mb-6'>
                                                            <span className="input-group-addon"><FaUser className='' /></span>
                                                            <Form.Control 
                                                              as="select" 
                                                              id="" 
                                                              name='patientType' 
                                                              onChange={ctx.handleChange}
                                                              isInvalid={!!ctx.state.patientRegErrors["patientType"]}
                                                              defaultValue="DEFAULT"
                                                            >
                                                              {ctx.state.patientTypeArr && ctx.state.patientTypeArr.map((option, index) => (
                                                                <option key={index} value={index === 0 ? "DEFAULT" : option} disabled={index === 0}>
                                                                  {option}
                                                                </option>
                                                              ))}
                                                            </Form.Control>
                                                            <div className="invalid-feedback">{ctx.state.patientRegErrors["patientType"]}</div>
                                                          </Form.Group>
                                                        </Col>
                                                        
                                                         {/* Referral Source - Main dropdown */}
                                                          {/* Referral Source - Main dropdown */}
                                                          <Col lg='6'>
                                                                <Form.Group className='input-group mb-6'>
                                                                  <span className="input-group-addon"><FaSearch className='' /></span>
                                                                  <Form.Control 
                                                                    as="select" 
                                                                    id="" 
                                                                    name='referralSource' 
                                                                    onChange={ctx.handleReferralSourceChange}
                                                                    isInvalid={!!ctx.state.patientRegErrors["referralSource"]}
                                                                    defaultValue="DEFAULT"
                                                                  >
                                                                    {ctx.state.referralSourceArr && ctx.state.referralSourceArr.map((option, index) => (
                                                                      <option key={index} value={index === 0 ? "DEFAULT" : option} disabled={index === 0}>
                                                                        {option}
                                                                      </option>
                                                                    ))}
                                                                  </Form.Control>
                                                                  <div className="invalid-feedback">{ctx.state.patientRegErrors["referralSource"]}</div>
                                                                </Form.Group>
                                                              </Col>
                                                        
                                                              {/* Conditional fields based on selection */}
                                                              {ctx.state.selectedReferralSource === 'Physician/Doctor' && (
                                                                <>
                                                                  <Col lg='6'>
                                                                    <Form.Group className='input-group mb-6'>
                                                                      <span className="input-group-addon"><FaUser className='' /></span>
                                                                      <Form.Control
                                                                        type='text'
                                                                        placeholder='Referring Physician'
                                                                        name='referringPhysician'
                                                                        onChange={ctx.handleChange}
                                                                        isInvalid={!!ctx.state.patientRegErrors["referringPhysician"]}
                                                                      />
                                                                      <div className="invalid-feedback">{ctx.state.patientRegErrors["referringPhysician"]}</div>
                                                                    </Form.Group>
                                                                  </Col>
                                                        
                                                                  <Col lg='6'>
                                                                    <Form.Group className='input-group mb-6'>
                                                                      <span className="input-group-addon"><FaPhoneAlt className='' /></span>
                                                                     {/* Referring Physician Phone field */}
                                                        <Form.Control
                                                            type='text'
                                                            placeholder='Referring Physician Phone'
                                                            name='referringPhysicianNumber'
                                                            value={ctx.state.referringPhysicianNumber || ''}
                                                            onChange={ctx.handleChange}
                                                            onKeyPress={(event) => {
                                                                if (!/[0-9]/.test(event.key)) {
                                                                    event.preventDefault();
                                                                }
                                                            }}
                                                            isInvalid={!!ctx.state.patientRegErrors["referringPhysicianNumber"]}
                                                        />
                                                                      <div className="invalid-feedback">{ctx.state.patientRegErrors["referringPhysicianNumber"]}</div>
                                                                    </Form.Group>
                                                                  </Col>
                                                                </>
                                                              )}
                                                        
                                                              {/* Hospital specific fields */}
                                                              {ctx.state.selectedReferralSource === 'Hospital' && (
                                                                <>
                                                                  <Col lg='6'>
                                                                    <Form.Group className='input-group mb-6'>
                                                                      <span className="input-group-addon"><FaHospital className='' /></span>
                                                                      <Form.Control
                                                                        type='text'
                                                                        placeholder='Hospital Name'
                                                                        name='referringHospital'  // Make sure this matches the variable name
                                                                        onChange={ctx.handleChange}
                                                                        isInvalid={!!ctx.state.patientRegErrors["referringHospital"]}
                                                                        />
                                                         
                                                                      <div className="invalid-feedback">{ctx.state.patientRegErrors["referringHospital"]}</div>
                                                                    </Form.Group>
                                                                  </Col>
                                                        
                                                                  <Col lg='6'>
                                                                    <Form.Group className='input-group mb-6'>
                                                                      <span className="input-group-addon"><FaUser className='' /></span>
                                                                      <Form.Control
                                                                        type='text'
                                                                        placeholder='Referring Physician'
                                                                        name='referringPhysician'
                                                                        onChange={ctx.handleChange}
                                                                        isInvalid={!!ctx.state.patientRegErrors["referringPhysician"]}
                                                                      />
                                                                      <div className="invalid-feedback">{ctx.state.patientRegErrors["referringPhysician"]}</div>
                                                                    </Form.Group>
                                                                  </Col>
                                                        
                                                                  <Col lg='6'>
                                                                    <Form.Group className='input-group mb-6'>
                                                                      <span className="input-group-addon"><FaPhoneAlt className='' /></span>
                                                                      <Form.Control
                                                                        type='text'
                                                                        placeholder='Referring Physician Phone'
                                                                        name='referringPhysicianNumber'  // This should match the state variable name
                                                                        onChange={ctx.handleChange}
                                                                        isInvalid={!!ctx.state.patientRegErrors["referringPhysicianNumber"]}
                                                                        />
                                                                      <div className="invalid-feedback">{ctx.state.patientRegErrors["referringPhysicianNumber"]}</div>
                                                                    </Form.Group>
                                                                  </Col>
                                                                </>
                                                              )}
                                                              
                                                              {/* For all other referral sources, show a general referral details field */}
                                                        {ctx.state.selectedReferralSource && 
                                                         ctx.state.selectedReferralSource !== 'Physician/Doctor' && 
                                                         ctx.state.selectedReferralSource !== 'Hospital' && 
                                                         ctx.state.selectedReferralSource !== 'DEFAULT' && (
                                                          <Col lg='6'>
                                                            <Form.Group className='input-group mb-6'>
                                                              <span className="input-group-addon"><FaInfoCircle className='' /></span>
                                                              <Form.Control
                                                          type='text'
                                                          placeholder='Referral Details'
                                                          name='referralDetails'  // Must match what you use in handleChange
                                                          value={ctx.state.referralDetails}  // Add this to make it a controlled component
                                                          onChange={ctx.handleChange}
                                                          isInvalid={!!ctx.state.patientRegErrors["referralDetails"]}
                                                        />
                                                              <div className="invalid-feedback">{ctx.state.patientRegErrors["referralDetails"]}</div>
                                                            </Form.Group>
                                                          </Col>
                                                        )}
    
                                                        <Col lg='12' className="form-button text-right">
                                                            <Button variant="secondary" onClick={() => ctx.nextButtonHandler()}>Next <FaChevronRight></FaChevronRight></Button>
                                                        </Col>
                                                    </Row>
                                                </div>
                                                <div id="nextTab" style={{ display: "none" }}>
                                                    <Row>
                                                    <Col lg="6">
                    <Form.Group className="input-group mb-6">
                        <span className="input-group-addon">
                            <FaBriefcaseMedical />
                        </span>
                        <Form.Control
                            as="select"
                            name="anyOngoingTreatment"
                            onChange={ctx.handleChange}
                            value={
                                ctx.state.anyOngoingTreatment
                                    ? ctx.state.anyOngoingTreatmentArr.find(option => option.name === ctx.state.anyOngoingTreatment)?.id || 'DEFAULT'
                                    : 'DEFAULT'
                            }
                        >
                            <option value="DEFAULT" disabled>- Any Ongoing Treatments -</option>
                            {ctx.state.anyOngoingTreatmentArr.map((option) => (
                                <option key={option.id} value={option.id}>
                                    {option.name}
                                </option>
                            ))}
                        </Form.Control>
                        <div className="invalid-feedback">
                            {ctx.state.patientRegErrors && ctx.state.patientRegErrors["anyOngoingTreatment"]}
                        </div>
                    </Form.Group>
                </Col>
    
                {/* Other Ongoing Treatment */}
                <Col lg="6">
                    {ctx.state.isOngoingTreatmentSelected && (
                        <Form.Group className='input-group mb-6'>
                            <span className="input-group-addon"><FaPlus /></span>
                            <Form.Control
                                as="textarea"
                                placeholder="Any ongoing treatment, please specify"
                                name="otherOngoingTreatment"
                                value={ctx.state.otherOngoingTreatment}
                                onChange={ctx.handleChange}
                                onInput={(e) => {
                                    e.target.style.height = 'auto';
                                    e.target.style.height = `${e.target.scrollHeight}px`;
                                }}
                                style={{ overflow: 'auto', resize: 'none', maxHeight: '150px' }}
                            />
                        </Form.Group>
                    )}
                </Col>
    
                {/* Comorbidities Selection */}
                <Col lg='6'>
                    <Form.Group className='input-group mb-6 customMultiselect'>
                        <span className="input-group-addon" style={{padding: "5px 4px"}}>
                            <GiMedicines />
                        </span>
                        <Multiselect
                            options={ctx.state.comorbiditiesArr}
                            selectedValues={ctx.state.selectedValue}
                            onSelect={ctx.setComorbidities.bind(this)}
                            onRemove={ctx.setComorbidities.bind(this)}
                            displayValue="name"
                            placeholder='- Select Comorbidities -'
                            closeOnSelect="true"
                        />
                    </Form.Group>
                </Col>
    
                {/* Other Comorbidities */}
                <Col lg='6'>
                    {ctx.state.isCommorbitiesSelected && (
                        <Form.Group className='input-group mb-6'>
                            <span className="input-group-addon"><FaPlus /></span>
                            <Form.Control 
                                type='textarea'
                                placeholder='Other Comorbidities, Please specify'
                                defaultValue={ctx.state.otherComorbidities}
                                name='otherComorbidities'
                                rows={2}
                                onChange={ctx.handleChange}
                            />
                        </Form.Group>
                    )}
                </Col>
    
                {/* Allergies Selection */}
                <Col lg='6'>
                    <Form.Group className='input-group mb-6 customMultiselect'>
                        <span className="input-group-addon" style={{padding: "5px 4px"}}>
                            <GiMedicines />
                        </span>
                        <Multiselect
                            options={ctx.state.allergiesArr}
                            selectedValues={ctx.state.selectedValue}
                            onSelect={ctx.setPatientAllergies.bind(this)}
                            onRemove={ctx.setPatientAllergies.bind(this)}
                            placeholder='- Select Allergies -'
                            displayValue="name"
                            closeOnSelect="true"
                        />
                    </Form.Group>
                </Col>
    
                {/* Other Allergies */}
                <Col lg='6'>
                    {ctx.state.isAllergiesSelected && (
                        <Form.Group className='input-group mb-6 customMultiselect'>
                            <span className="input-group-addon"><GiMedicines /></span>
                            <Form.Control 
                                as="textarea"
                                placeholder='Other Allergies, Please specify'
                                defaultValue={ctx.state.allergies}
                                name='allergies'
                                rows={2}
                                onChange={ctx.handleChange}
                                style={{width: '100%'}}
                            />
                        </Form.Group>
                    )}
                </Col>
                {ctx.state.isRestrictedFieldsVisible && (
                <>
                    <Col lg='6'>
                        <Form.Group className='input-group mb-6'>
                            <span className="input-group-addon">
                                <FaBriefcaseMedical className='' />
                            </span>
                            <Form.Control as="select" name='category' onChange={ctx.handleChange}>
                                {ctx.state.categoryOptions.map((option, index) => (
                                    <option key={index} value={option === 'Select Category' ? '' : option}>
                                        {option}
                                    </option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                    </Col>
    
                    <Col lg='6'>
                        <Form.Group className='input-group mb-6'>
                            <span className="input-group-addon">
                                <FaBriefcaseMedical className='' />
                            </span>
                            <Form.Control as="select" name='company' onChange={ctx.handleChange}>
                                {ctx.state.companyOptions.map((option, index) => (
                                    <option key={index} value={option === 'Select Company' ? '' : option}>
                                        {option}
                                    </option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                    </Col>
    
                    <Col lg='6'>
                        <Form.Group className='input-group mb-6'>
                            <span className="input-group-addon">
                                <FaBriefcaseMedical className='' />
                            </span>
                            <Form.Control as="select" name='tarrif' onChange={ctx.handleChange}>
                                {ctx.state.tarrifOptions.map((option, index) => (
                                    <option key={index} value={option === 'Select Tarrif' ? '' : option}>
                                        {option}
                                    </option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                    </Col>
    
                    <Col lg='6'>
                        <Form.Group className='input-group mb-6'>
                            <span className="input-group-addon">
                                <FaBriefcaseMedical className='' />
                            </span>
                            <Form.Control as="select" name='payType' onChange={ctx.handleChange}>
                                {ctx.state.payTypeOptions.map((option, index) => (
                                    <option key={index} value={option === 'Select Pay Type' ? '' : option}>
                                        {option}
                                    </option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                    </Col>
    
                    {/* <Col lg='6'>
                        <Form.Group className='input-group mb-6'>
                            <span className="input-group-addon">
                                <FaBriefcaseMedical className='' />
                            </span>
                            <Form.Control as="select" name='status' onChange={ctx.handleChange}>
                                {ctx.state.statusOptions.map((option, index) => (
                                    <option key={index} value={option === 'Select Status' ? '' : option}>
                                        {option}
                                    </option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                    </Col> */}
                </>
            )}
    
                                                        <Col lg='6'>
                                                                        <Form.Group className='input-group mb-6'>
                                                                            <span className="input-group-addon"><FaUser /></span>
                                                                            <Form.File
                                                                                type="file"
                                                                                id="inputGroupFile01"
                                                                                label="Upload Profile Pic"
                                                                                onChange={ctx.profilePicHandler}
                                                                            />
                                                                            <div className="invalid-feedback">{ctx.state.errors["profilePicture"]}</div>
                                                                        </Form.Group>
                                                                        {ctx.state.profilePictureData1 && (
                                                                            <img src={ctx.state.profilePictureData1} alt={ctx.state.profilePictureName1} style={{ width: "100px", height: "100px" }} />
                                                                        )}
                                                                    </Col>
                                                        
                                                        <Col lg='12' className="form-button">
                                                            <Button className="pull-left btn btn-info" onClick={() => ctx.previousButtonHandler()}><FaChevronLeft></FaChevronLeft> Previous</Button>
                                                            <Button className="pull-right" variant="secondary" onClick={ctx.savePatientDetial.bind(ctx)}>
                                                                {ctx.state.saveLoader && (
                                                                    <Spinner className='mr-3' animation='border' size='1.5rem' />
                                                                )}
                                                                Submit
                                                            </Button>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </div>
                                        }
                                    </Container>
                                </Modal.Body>
                            </Modal>
  );
}
